import { Outlet, useNavigate } from 'react-router-dom'
import { useEffect, useContext } from 'react';
import { getDefaultLandingPage } from "../../../utils/permissions";
import { UserContext } from "../../../contexts/UserContext";

export const AuthLayout = () => {
  const navigate = useNavigate()
  const isUser = localStorage.getItem("user");
  const { user } = useContext(UserContext);

  useEffect(() => {
    if (!isUser || !user) return;
    if (user.isApproved) {
      navigate(getDefaultLandingPage(user));
    } else {
      navigate("/unAuthPage");
    }
  }, [isUser, user])
  return (
    <div>
      <Outlet />
    </div>
  )
}
